Auth = require 'app/scripts/db/auth'

module.exports = ->
  return if !Auth.isLoggedIn()
  member = Auth.me()
  timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone
  if !!member && timezone != member.getPref('timezone')
    member.api {
      type: 'put'
      method: 'prefs/timezone'
      data: { value: timezone }
    }
